// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import pstratEntity from './entities/pstrat.json';
import pstratMenu from '../pages/pstrat/menu.json';
import pstratFullForm from '../pages/pstrat/forms/full.json';
import pstratContextForm from '../pages/pstrat/forms/context.json';
import pstratMiniForm from '../pages/pstrat/forms/mini.json';
import pstratLookupForm from '../pages/pstrat/forms/lookup.json';
import pstratTableView from '../pages/pstrat/views/table.json';
import pstratStagesView from '../pages/pstrat/views/stages.json';
import pstratCardsView from '../pages/pstrat/views/cards.json';
import pstratInlineView from '../pages/pstrat/views/inline.json';
import pstratBacklogView from '../pages/pstrat/views/backlog.json';
import pstratSplitView from '../pages/pstrat/views/split.json';
import pstratCalendarView from '../pages/pstrat/views/calendar.json';
import pstratDashboardView from '../pages/pstrat/views/dashboard.json';

/** Тип запису «Стратегічна ціль» зі сторінками пакета: меню, форми та подання з pages/pstrat/. */
export const pstratDefinition: IRecordTypeDefinition = {
  ...pstratEntity,
  views: assembleViewSet({
      table: pstratTableView,
      stages: pstratStagesView,
      cards: pstratCardsView,
      inline: pstratInlineView,
      backlog: pstratBacklogView,
      split: pstratSplitView,
      calendar: pstratCalendarView,
      dashboard: pstratDashboardView,
  }),
  form: pstratFullForm,
  forms: { full: pstratFullForm, context: pstratContextForm, mini: pstratMiniForm, lookup: pstratLookupForm },
  menu: pstratMenu,
} as IRecordTypeDefinition;
